import styled from 'styled-components';

import Picture from 'components/picture';

const StyledPicture = styled(Picture)`
  max-height: 50vh;
  max-width: 50vh;
  margin: 0 auto;
`;

export default StyledPicture;
